import {
  MANUAL_PO_LIFECYCLE_ERROR,
  MANUAL_PO_LIFECYCLE_REQUEST,
  RESET_MANUAL_PO_LIFECYCLE,
  MANUAL_PO_LIFECYCLE_SUCCESS,
} from "redux/actions/action-type";

const initialState = {
  orders: [],
  errorDetails: {},
  metadata: {},
  isPOLifecycleLoading: false,
  isPOLifecycleError: false,
  isPOLifecycleSuccess: false,
};

const poLifeCycleReducer = (state = initialState, action) => {
  switch (action.type) {
    case MANUAL_PO_LIFECYCLE_REQUEST:
      return {
        ...state,
        isPOLifecycleLoading: true,
        isPOLifecycleError: false,
        isPOLifecycleSuccess: false,
      };

    case MANUAL_PO_LIFECYCLE_SUCCESS:
      const { orders: newOrders, metadata: newMetadata } = action.payload;
      const { orders: existingOrders } = state;
      let mergedOrders;
      if (existingOrders) {
        mergedOrders = [...existingOrders, ...newOrders];
      } else {
        mergedOrders = newOrders;
      }
      return {
        ...initialState,
        isPOLifecycleLoading: false,
        orders: mergedOrders,
        metadata: newMetadata,
        isPOLifecycleError: false,
        isPOLifecycleSuccess: true,
        errorDetails: {},
      };

    case MANUAL_PO_LIFECYCLE_ERROR:
      return {
        ...state,
        isPOLifecycleLoading: false,
        orders: [],
        isPOLifecycleError: true,
        isPOLifecycleSuccess: false,
        errorDetails: action.payload,
      };

    case RESET_MANUAL_PO_LIFECYCLE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default poLifeCycleReducer;
